/**
 * Rehber yazıları (Türkçe). Her yazı: başlık, özet, kapak için kategori, bölümler ve ilgili bağlantılar.
 * Bölüm metinleri genel teknik bilgiye dayanır; kesin değerler için ürün teknik föyleri esas alınmalıdır.
 */
export const REHBERLER = [
  {
    slug: "gazbeton-mu-tugla-mi",
    baslik: "Gazbeton mu, tuğla mı? Duvar malzemesi seçimi",
    ozet: "Ağırlık, ısı ve ses yalıtımı, işçilik hızı ve uygulama farklarıyla gazbeton ve tuğlayı karşılaştırıyoruz.",
    kapakKategori: "gazbeton",
    okuma: 5,
    urunKategorileri: ["gazbeton", "tuglalar"],
    bolumler: [
      {
        baslik: "Kısa cevap",
        paragraflar: [
          "İkisi de doğru uygulandığında sağlam ve uzun ömürlü duvar örer. Seçimi belirleyen; duvarın taşıyıcı mı dolgu mu olduğu, istenen ısı ve ses yalıtımı, binanın yükü ve işçilik planıdır.",
          "Hafiflik, yüksek ısı yalıtımı ve hızlı örgü öne çıkıyorsa gazbeton; ses yalıtımı, darbe dayanımı ve alışılmış işçilik öne çıkıyorsa tuğla genellikle daha uygun olur.",
        ],
      },
      {
        baslik: "Isı yalıtımı",
        paragraflar: [
          "Gazbeton, içindeki kapalı hava gözenekleri sayesinde düşük ısı iletkenliğine sahiptir. Kataloğumuzdaki Ytong blokların ısı iletkenlik değerleri 0,08–0,18 W/mK aralığındadır; değer düştükçe yalıtım artar.",
          "Tuğlada da ısı yalıtımlı seriler vardır: Kilsan Termokil gibi yalıtım tuğlaları, klasik delikli tuğlaya göre daha iyi sonuç verir. Dış duvarlarda hangi malzeme seçilirse seçilsin, yönetmeliğe uygun ısı yalıtımı hesabı yapılmalıdır.",
        ],
      },
      {
        baslik: "Ses yalıtımı",
        paragraflar: [
          "Ses yalıtımı büyük ölçüde duvarın kütlesine bağlıdır. Daha ağır olan tuğla duvarlar, aynı kalınlıktaki hafif gazbeton duvarlara göre sesi genellikle daha iyi keser.",
          "Daireler arası ve gürültülü mekânlara komşu duvarlarda akustik tuğlalar ya da çift katmanlı çözümler tercih edilebilir.",
        ],
      },
      {
        baslik: "Ağırlık ve işçilik",
        paragraflar: [
          "Gazbeton bloklar hafif ve büyük ebatlıdır (ör. 60 × 25 cm). Metrekareye daha az blok girer ve ince yapıştırma harcıyla (yaklaşık 2–3 mm) örüldüğü için duvar hızlı yükselir, binaya binen yük azalır.",
          "Tuğla daha küçük ebatlıdır ve yaklaşık 1 cm kalınlığında örgü harcıyla örülür. Metrekareye düşen adet ve harç miktarı daha fazladır.",
        ],
        liste: [
          "Gazbeton kolayca kesilir ve oyulur; tesisat kanalı açmak pratiktir.",
          "Gazbeton duvara ağır yük asarken gazbetona uygun dübel kullanılmalıdır.",
          "Gazbeton su emebilir; dış yüzeylerde uygun sıva ve boya ile korunmalıdır.",
        ],
      },
      {
        baslik: "Ne kadar malzeme lazım?",
        paragraflar: [
          "Duvar ölçünüzü ve blok tipini girerek gereken adet ile harç miktarını malzeme hesaplayıcımızla bulabilirsiniz. Hesaplayıcı katalogdaki Kilsan ve Ytong ürünlerinin gerçek ölçülerini kullanır.",
        ],
      },
    ],
    baglantilar: [
      { etiket: "Tuğla ve gazbeton hesaplayıcı", yol: "/hesaplayicilar?tur=duvar" },
      { etiket: "Gazbeton blokları", yol: "/urunler/gazbeton" },
      { etiket: "Tuğlalar", yol: "/urunler/tuglalar" },
      { etiket: "Toptan / şantiye teklifi", yol: "/toptan-teklif" },
    ],
  },
  {
    slug: "ic-cephe-boyasi-nasil-secilir",
    baslik: "İç cephe boyası nasıl seçilir?",
    ozet: "Boya türleri, parlaklık seçenekleri, ıslak mekânlar, astar ihtiyacı ve doğru uygulama adımları.",
    kapakKategori: "ic-cephe-boyalari",
    okuma: 5,
    urunKategorileri: ["ic-cephe-boyalari", "tavan-boyalari", "astar-ve-macunlar", "boya-rulolari"],
    bolumler: [
      {
        baslik: "Önce mekânı düşünün",
        paragraflar: [
          "Salon ve yatak odası gibi kuru mekânlarda silinebilir, mat ya da ipek mat su bazlı boyalar yaygın tercihtir. Çocuk odası, koridor ve mutfak gibi sık temizlenen yerlerde silinebilirliği yüksek, silikonlu (silan katkılı) boyalar daha dayanıklı olur.",
          "Banyo ve mutfak gibi nemli mekânlarda küf ve mantar oluşumuna karşı katkılı, ıslak mekân için üretilmiş boyalar seçilmelidir. Tavanlarda ise tavan boyaları hem daha ekonomik hem de uygulaması daha kolaydır.",
        ],
      },
      {
        baslik: "Parlaklık: mat, ipek mat, yarı mat",
        liste: [
          "Mat: Yüzeydeki küçük kusurları gizler, sakin ve modern bir görünüm verir.",
          "İpek mat: Hafif parlaklık sayesinde daha kolay silinir; en çok tercih edilen orta yoldur.",
          "Yarı mat ve parlak: Temizlenmesi en kolay yüzeylerdir; ancak duvardaki dalgalanmaları daha belirgin gösterir.",
        ],
      },
      {
        baslik: "Astar gerekli mi?",
        paragraflar: [
          "Yeni sıva, alçı ya da alçıpan yüzeylerde, emiciliği yüksek veya tozuyan zeminlerde ve koyu renkten açık renge geçerken astar kullanılmalıdır. Astar, boyanın yüzeye tutunmasını artırır ve sarfiyatı düşürür.",
          "Daha önce aynı tipte boyayla boyanmış, sağlam ve temiz yüzeylerde çoğu zaman doğrudan boyaya geçilebilir. Ürün etiketindeki uygulama talimatı her zaman önceliklidir.",
        ],
      },
      {
        baslik: "Uygulama adımları",
        liste: [
          "Yüzeyi tozdan, yağdan ve kabarmış eski boyadan temizleyin.",
          "Çatlak ve delikleri macunla doldurun, kuruduktan sonra zımparalayın.",
          "Gerekiyorsa astar uygulayın ve kurumasını bekleyin.",
          "Boyayı iki kat, katlar arasında etikette belirtilen kuruma süresini bekleyerek uygulayın.",
          "Köşeler ve kenarlar için fırça, geniş yüzeyler için uygun tüylü rulo kullanın.",
        ],
      },
      {
        baslik: "Ne kadar boya alacağım?",
        paragraflar: [
          "İç cephe boyalarında sarfiyat genellikle tek katta 8–12 m²/L aralığındadır; kesin değer ürün etiketinde yazar. Oda ölçünüzü ve kat sayısını girerek litre ile önerilen ambalaj birleşimini boya hesaplayıcımızla bulabilirsiniz.",
        ],
      },
    ],
    baglantilar: [
      { etiket: "Boya hesaplayıcı", yol: "/hesaplayicilar?tur=boya" },
      { etiket: "İç cephe boyaları", yol: "/urunler/ic-cephe-boyalari" },
      { etiket: "Astar ve macunlar", yol: "/urunler/astar-ve-macunlar" },
      { etiket: "Boya ruloları", yol: "/urunler/boya-rulolari" },
    ],
  },
  {
    slug: "hangi-silikon-nereye",
    baslik: "Hangi silikon nereye? Silikon, mastik ve köpük rehberi",
    ozet: "Asetik ve nötr silikon, akrilik ve poliüretan mastik, MS polimer, ısı silikonu ve PU köpük: hangisi hangi iş için?",
    kapakKategori: "silikonlar",
    okuma: 6,
    urunKategorileri: ["silikonlar", "mastikler", "pu-kopukler", "montaj-yapistiricilari", "silikon-ve-kopuk-tabancalari"],
    bolumler: [
      {
        baslik: "Asetik (genel amaçlı) silikon",
        paragraflar: [
          "Kürlenirken sirke kokusu yayan silikonlardır. Cam, seramik, fayans ve banyo-mutfak derzlerinde yaygın kullanılır; hızlı kürlenir ve ekonomiktir.",
          "Asitli yapısı nedeniyle mermer ve doğal taşta lekelenmeye, bazı metallerde korozyona yol açabilir. Bu yüzeylerde nötr silikon tercih edilmelidir.",
        ],
      },
      {
        baslik: "Nötr silikon",
        paragraflar: [
          "Kokusuz ya da az kokulu kürlenir; mermer, beton, metal, PVC ve alüminyum doğrama, cephe ve ayna uygulamalarına uygundur. Dış mekân dayanımı genellikle daha yüksektir.",
        ],
      },
      {
        baslik: "Boyanacak derzler: akrilik (silikonize) mastik",
        paragraflar: [
          "Silikonun üzerine boya tutmaz. Kapı-pencere kasası kenarları, alçı ve sıva çatlakları gibi sonradan boyanacak iç mekân derzlerinde boyanabilir akrilik mastik kullanılır.",
        ],
      },
      {
        baslik: "Hareketli derzler: poliüretan ve MS polimer",
        paragraflar: [
          "Poliüretan (PU) mastikler; zemin derzleri, dilatasyonlar ve beton birleşimleri gibi hareket eden noktalarda esnekliğini koruyarak çalışır.",
          "MS polimer (hibrit) ürünler hem mastik hem yapıştırıcı olarak kullanılabilir; nemli yüzeylere tutunabilir ve çoğu boyanabilir. Kesin uygulama koşulları için ürün etiketine bakılmalıdır.",
        ],
      },
      {
        baslik: "Özel durumlar",
        liste: [
          "Yüksek ısı silikonu (genellikle kırmızı): soba, baca bağlantısı ve motor gibi sıcak yüzeylerde.",
          "Poliüretan montaj köpüğü: kapı-pencere montajı, boşluk ve delik dolgusu. Tabancalı köpük daha kontrollü, pipetli köpük pratiktir.",
          "Yangın dayanımlı köpükler: yangın güvenliği gereken geçişlerde, belirtilen sınıfa uygun olarak.",
          "Montaj yapıştırıcıları: çivi ve vida kullanmadan panel, profil ve süpürgelik yapıştırmak için.",
        ],
      },
      {
        baslik: "Uygulama ipuçları",
        liste: [
          "Yüzey kuru, tozsuz ve yağsız olmalı; eski silikon tamamen temizlenmelidir.",
          "Düzgün bir derz için kenarlara maskeleme bandı yapıştırın ve silikonu çektikten sonra bandı hemen alın.",
          "Kartuşlar için iskelet ya da kutu tipi silikon tabancası, köpük için köpük tabancası kullanın.",
        ],
      },
    ],
    baglantilar: [
      { etiket: "Silikonlar", yol: "/urunler/silikonlar" },
      { etiket: "Mastikler", yol: "/urunler/mastikler" },
      { etiket: "PU köpükler", yol: "/urunler/pu-kopukler" },
      { etiket: "Silikon ve köpük tabancaları", yol: "/urunler/silikon-ve-kopuk-tabancalari" },
    ],
  },
  {
    slug: "matkap-secimi-darbeli-sds-akulu",
    baslik: "Matkap seçimi: darbeli matkap, SDS kırıcı-delici ve akülü vidalama",
    ozet: "Hangi iş için hangi makine? Volt, akü, kömürsüz motor ve doğru uç seçimi.",
    kapakKategori: "akulu-el-aletleri",
    okuma: 6,
    urunKategorileri: ["akulu-el-aletleri", "elektrikli-el-aletleri", "beton-matkap-uclari"],
    bolumler: [
      {
        baslik: "İşe göre makine",
        liste: [
          "Matkap / vidalama (darbesiz): Ahşap, metal ve plastik delme, vida sıkma. Mobilya montajı ve genel tamirat için idealdir.",
          "Darbeli matkap: Tuğla ve hafif betonda küçük çaplı delikler için darbe modu vardır. Ara sıra duvar delenler için pratik bir çözümdür.",
          "SDS-Plus kırıcı-delici: Betonarme ve sert betonda hızlı delme ve hafif kırma için. Şantiye ve tesisat işlerinin temel makinesidir.",
          "SDS-Max kırıcı-delici ve kırıcılar: Büyük çaplı delikler, karot ve yoğun kırma işleri için.",
          "Darbeli vidalama ve somun sıkma: Uzun vidalar, çelik konstrüksiyon ve yüksek tork gereken bağlantılar için.",
        ],
      },
      {
        baslik: "Akülü makinede volt ve akü",
        paragraflar: [
          "12V makineler hafif ve kompakttır; dar alanlar ve hafif işler için uygundur. 18V, genel kullanımda güç ile ağırlık arasındaki en yaygın dengedir. 54V (FlexVolt) seri, kablolu makinelere yakın güç isteyen ağır işler içindir.",
          "Akünün Ah değeri çalışma süresini belirler: 5 Ah bir akü, aynı makinede 2 Ah aküden daha uzun çalışır. “Gövde” ya da “akü hariç” yazan ürünlerde akü ve şarj cihazı kutuda yoktur; aynı marka ve seride aküsü olanlar için ekonomik bir seçimdir.",
        ],
      },
      {
        baslik: "Kömürsüz (brushless) motor ne sağlar?",
        paragraflar: [
          "Kömürsüz motorlarda sürtünmeyle aşınan kömür fırçalar yoktur. Bu sayede aynı akü ile daha uzun çalışma, daha az ısınma ve daha uzun motor ömrü elde edilir. Yoğun kullanımda fiyat farkını genellikle karşılar.",
        ],
      },
      {
        baslik: "Doğru uç seçimi",
        liste: [
          "Beton ve taş: SDS-Plus / SDS-Max beton uçları ya da darbeli matkap için silindirik saplı beton uçları.",
          "Metal: HSS ve HSS-G (taşlanmış) metal matkap uçları.",
          "Ahşap: Yassı (kelebek), helezon ve forstner ahşap uçları.",
          "Seramik ve cam: Seramik / fayans için özel karbür ya da elmas uçlar; darbe modu kapalı kullanılmalıdır.",
        ],
      },
      {
        baslik: "Karşılaştırarak seçin",
        paragraflar: [
          "Ürün kartlarındaki “Karşılaştır” düğmesiyle en fazla dört makineyi seçip voltaj, akü durumu, motor tipi ve özelliklerini yan yana görebilirsiniz. Akülü el aletleri sayfasındaki voltaj ve akü filtreleri de listeyi hızla daraltır.",
        ],
      },
    ],
    baglantilar: [
      { etiket: "Akülü el aletleri", yol: "/urunler/akulu-el-aletleri" },
      { etiket: "Elektrikli el aletleri", yol: "/urunler/elektrikli-el-aletleri" },
      { etiket: "Beton matkap uçları (SDS)", yol: "/urunler/beton-matkap-uclari" },
      { etiket: "DeWalt ürünleri", yol: "/marka/dewalt" },
    ],
  },
  {
    slug: "seramik-yapistiricisi-ve-derz-dolgusu-secimi",
    baslik: "Seramik döşerken yapıştırıcı ve derz dolgusu nasıl seçilir?",
    ozet: "C1–C2, T, E ve S sınıfları ne anlama gelir? Derz dolgusunda CG2 ve epoksi farkı, tarak ve sarfiyat.",
    kapakKategori: "seramik-mermer-yapistiricilari",
    okuma: 5,
    urunKategorileri: ["seramik-mermer-yapistiricilari", "derz-dolgulari"],
    bolumler: [
      {
        baslik: "Yapıştırıcı sınıfları (TS EN 12004)",
        paragraflar: ["Çimento esaslı seramik yapıştırıcılarının torbasında yazan harf ve rakamlar ürünün performansını gösterir:"],
        liste: [
          "C1: Normal performanslı; iç mekânda küçük ve orta ebatlı seramikler için.",
          "C2: Geliştirilmiş performanslı; büyük ebat, granit seramik, dış mekân ve zorlu zeminler için.",
          "T: Kayması azaltılmış; duvar uygulamalarında seramiğin aşağı kaymasını önler.",
          "E: Uzatılmış açık süreli; sıcak havada ve geniş alanlarda çalışma kolaylığı sağlar.",
          "S1 / S2: Deformasyon (esneme) yeteneği; yerden ısıtma, dış cephe ve hareketli zeminlerde tercih edilir.",
          "F: Hızlı priz alan; kısa sürede kullanıma açılması gereken yerler için.",
        ],
      },
      {
        baslik: "Büyük ebatlı seramiklerde dikkat",
        paragraflar: [
          "60 × 60 cm ve üzeri seramiklerde uygun dişli tarak kullanılmalı; boşluksuz bir yatak için yapıştırıcı hem zemine hem de seramiğin arkasına sürülmelidir (çift taraflı uygulama). Bu yöntem sarfiyatı artırır ancak kırılma ve ses yapma riskini azaltır.",
        ],
      },
      {
        baslik: "Derz dolgusu (TS EN 13888)",
        liste: [
          "CG1: Normal çimento esaslı derz dolgusu.",
          "CG2: Geliştirilmiş; aşınma ve su emme dayanımı daha yüksektir. W harfi su emmesi azaltılmış, A harfi aşınma dayanımı yüksek anlamına gelir.",
          "RG (epoksi): Su, asit ve lekelenmeye karşı en dayanıklı sınıf; mutfak tezgâhı, havuz ve endüstriyel alanlar için.",
        ],
      },
      {
        baslik: "Ne kadar yapıştırıcı ve derz dolgusu lazım?",
        paragraflar: [
          "Yapıştırıcı sarfiyatı seramik ebadına ve tarağa göre değişir; küçük ebatlarda metrekareye birkaç kilogram, büyük ebatlarda daha fazlası gerekir. Derz dolgusu miktarı ise seramik ölçüsü, kalınlığı ve derz genişliğine bağlıdır. Seramik hesaplayıcımız bu değerlerden kutu, yapıştırıcı torbası ve derz dolgusu miktarını birlikte hesaplar.",
        ],
      },
    ],
    baglantilar: [
      { etiket: "Seramik hesaplayıcı", yol: "/hesaplayicilar?tur=seramik" },
      { etiket: "Seramik yapıştırıcıları", yol: "/urunler/seramik-mermer-yapistiricilari" },
      { etiket: "Derz dolguları", yol: "/urunler/derz-dolgulari" },
      { etiket: "Kalekim ürünleri", yol: "/marka/kalekim" },
    ],
  },
];

export const rehberBul = (slug) => REHBERLER.find((r) => r.slug === slug);
